import { useState, useEffect } from "react";
import { nanoid } from "nanoid";
import Die from "./Die";
import Confetti from 'react-confetti'

function App() {
  const [randNumber, setRandNumber] = useState(randomDice());
  const [gameOver, setGameOver] = useState(false);
  const [rollCount, setRollCount] = useState(1);
  const [timer, setTimer] = useState(0);
  const [msg, setMsg] = useState(
    "The worlds fastest game! Everyone gets ten dice. Someone says, Go."
  );

  function randomDice() {
    const arr = [];
    for (let i = 0; i < 10; i++) {
      arr.push(generateRadom());
    }
    return arr;
  }

  function generateRadom() {
    const data = {
      value: Math.ceil(Math.random() * 6),
      isHeld: false,
      id: nanoid(),
    };
    return data;
  }

  function handleRollDice() {
    setRollCount((count) => count + 1);
    setRandNumber(
      randNumber.map((rand) =>
        rand.isHeld === true ? { ...rand } : generateRadom()
      )
    );
  }

  const holdDice = (id) => {
    setRandNumber(
      randNumber.map((dice) =>
        dice.id === id ? { ...dice, isHeld: !dice.isHeld } : dice
      )
    );
  };

  const resetGame = () => {
    setGameOver(false);
    setRandNumber(randomDice());
    setRollCount(1);
    setMsg('The worlds fastest game! Everyone gets ten dice. Someone says, Go.')
  };

  useEffect(() => {
    if (
      randNumber.every(
        (val) => val.isHeld === true && val.value === randNumber[0].value
      )
    ) {
      setGameOver(true);
      setMsg(`Wow, you won the game in ${rollCount} rolls`);
    }
    if (timer === 60) {
      setGameOver(true);
      setMsg("Times Up, you lose the Game! try again");
    }
  }, [randNumber, timer]);

  useEffect(() => {
    let times;
    if (!gameOver) {
      times = setTimeout(() => {
        setTimer((time) => time + 1);
      }, 1000);
    } else {
      clearTimeout(times);
      setTimer(0);
    }
  }, [timer, gameOver]);

  useEffect(() => { }, []);

  return (
    <main>
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      {gameOver && <Confetti />}
      {gameOver ? (
        <>
          <h2>Game Over</h2>
          <p>{msg}</p>
          <button className="dice-roll-btn" onClick={resetGame}>
            Play Again
          </button>
        </>
      ) : (
        <>

          <h2>Tenzies</h2>
          <header>
            <div>Number of Roll: <span className="head-result">{rollCount}</span></div>
            <div>Time: <span className="head-result">{timer}</span></div>
          </header>
          <p>{msg}</p>
          <div className="dice-Container">
            {randNumber.map((random) => (
              <Die key={random.id} randomObj={random} onHoldDice={holdDice} />
            ))}
          </div>
          <button className="dice-roll-btn" onClick={handleRollDice}>
            Roll Dice
          </button>
        </>
      )}
    </main>
  );
}

export default App;
